// src/pages/gears/Gears.js

import "../../App.css";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import Header from "../../components/Header";
import Footer from "../../components/Footer";

// Camera images
import x2Img from "./gearimages/x2.jpg";
import x3Img from "./gearimages/x3.jpg";
import x4Img from "./gearimages/x4.jpg";
import gpmaxImg from "./gearimages/gpmax.jpg";
import gp8Img from "./gearimages/gp8.jpg";
import gp9Img from "./gearimages/gp9.jpg";
import djipocketImg from "./gearimages/djipocket.jpg";


// Drone images
import neoImg from "./gearimages/drone.jpg";
import mavicpro2Img from "./gearimages/mavicpro2.jpg";

export default function Gears() {
  const navigate = useNavigate();

  // CAMERA ITEMS
  const cameraItems = [
    { name: "Insta360 X2", image: x2Img, tagline: "Pocket‑size 360 camera", route: "/gear/instax2" },
    { name: "Insta360 X3", image: x3Img, tagline: "Most popular 360 camera", route: "/gear/instax3" },
    { name: "Insta360 X4", image: x4Img, tagline: "8K 360° video", route: "/gear/instax4" },
    { name: "GoPro Hero 8", image: gp8Img, tagline: "4K60 HyperSmooth 2.0", route: "/gear/gopro8" },

    // ⭐ FIXED HERO 9 ENTRY
    { name: "GoPro Hero 9", image: gp9Img, tagline: "5K30 • 20MP • Front Screen", route: "/gear/gopro9" },
    {name: "djipocket", image: djipocketImg, tagline: "4K60 • 64MP • Gimbal", route: "/gear/djipocket"},

    { name: "GoPro Max", image: gpmaxImg, tagline: "Dual‑lens 360 capture", route: "/gear/gopromax" }
  ];

  // DRONE ITEMS
  const droneItems = [
    { name: "DJI Neo", image: neoImg, tagline: "Compact and powerful", route: "/gear/neo" },
    { name: "DJI Mavic Pro 2", image: mavicpro2Img, tagline: "Legendary aerial quality", route: "/gear/mavicpro" }
  ];

  // ACTIVE INDEXES
  const [cameraIndex, setCameraIndex] = useState(0);
  const [droneIndex, setDroneIndex] = useState(0);

  // ANIMATION STATES
  const [cameraSlide, setCameraSlide] = useState("");
  const [droneSlide, setDroneSlide] = useState("");

  // CAMERA — NEXT / PREV
  const nextCamera = () => {
    setCameraSlide("slide-left");
    setTimeout(() => {
      setCameraIndex((cameraIndex + 1) % cameraItems.length);
      setCameraSlide("");
    }, 300);
  };

  const prevCamera = () => {
    setCameraSlide("slide-right");
    setTimeout(() => {
      setCameraIndex((cameraIndex - 1 + cameraItems.length) % cameraItems.length);
      setCameraSlide("");
    }, 300);
  };

  // DRONE — NEXT / PREV
  const nextDrone = () => {
    setDroneSlide("slide-left");
    setTimeout(() => {
      setDroneIndex((droneIndex + 1) % droneItems.length);
      setDroneSlide("");
    }, 300);
  };

  const prevDrone = () => {
    setDroneSlide("slide-right");
    setTimeout(() => {
      setDroneIndex((droneIndex - 1 + droneItems.length) % droneItems.length);
      setDroneSlide("");
    }, 300);
  };

  return (
    <>
      <Header />

      <div className="gear-back-button-wrapper">
        <button className="gear-back-button" onClick={() => navigate(-1)}>
          ← Back
        </button>
      </div>

      <div className="gear-wrapper">
        <div className="gear-row">

          {/* LEFT COLUMN — CAMERAS */}
          <div className="gear-column">
            <div className="stacked-card-container">

              {/* SMALL CORNER BACK CARD */}
              <div className="stacked-card back-card"></div>

              {/* FRONT CARD */}
              <div
                className={`stacked-card front-card ${cameraSlide}`}
                onClick={() => navigate(cameraItems[cameraIndex].route)}
              >
                <img src={cameraItems[cameraIndex].image} alt="" />
                <h3>{cameraItems[cameraIndex].name}</h3>
                <p>{cameraItems[cameraIndex].tagline}</p>
              </div>

              <button className="stack-arrow left" onClick={prevCamera}>❮</button>
              <button className="stack-arrow right" onClick={nextCamera}>❯</button>
            </div>
          </div>

          {/* RIGHT COLUMN — DRONES */}
          <div className="gear-column">
            <div className="stacked-card-container">

              <div className="stacked-card back-card"></div>

              <div
                className={`stacked-card front-card ${droneSlide}`}
                onClick={() => navigate(droneItems[droneIndex].route)}
              >
                <img src={droneItems[droneIndex].image} alt="" />
                <h3>{droneItems[droneIndex].name}</h3>
                <p>{droneItems[droneIndex].tagline}</p>
              </div>

              <button className="stack-arrow left" onClick={prevDrone}>❮</button>
              <button className="stack-arrow right" onClick={nextDrone}>❯</button>
            </div>
          </div>

        </div>
      </div>

      <Footer />
    </>
  );
}
